#import "../fragments/contact-info-fragment.graphql"

mutation UpdateContactInfo($input: ContactUpdateInput!) {
    contactUpdate(input: $input) {
        contact {
            ...ContactInfoFragment
        }
    }
}
